import { Calendar } from 'element-ui'

const YCalendar = Calendar
YCalendar.$depends = [Calendar]
YCalendar.$name = 'y-calendar'
YCalendar._name = 'Calendar 日历'

export default YCalendar
